import React from "react";
import PropTypes from "prop-types";

import { useFinaidYear } from "components/hooks/useFinaidYear";
import { ItemDetails } from "./ItemDetails";
import { SectionTitle } from "./SectionTitle";
import { SectionSummary } from "./SectionSummary";
import { SectionAccordion } from "./SectionAccordion";

export function GiftAid({ showDecimals }) {
  const { giftaid, messageEstDisbursements } = useFinaidYear(
    ({
      finaidAwards: {
        awards: { giftaid } = {},
        messages: { messageEstDisbursements } = {},
      },
    }) => ({
      giftaid,
      messageEstDisbursements,
    })
  );

  const {
    total: { title, amount: total } = {},
    links = [],
    items = [],
  } = giftaid;

  return (
    <>
      <SectionTitle title={title} links={links} />

      {items.length > 0 ? (
        <>
          <SectionAccordion collapsible multiple color="regent-st-blue">
            {items.map((item, index) => (
              <ItemDetails
                key={index}
                item={item}
                messageEstDisbursements={messageEstDisbursements}
                showDecimals={showDecimals}
              />
            ))}
          </SectionAccordion>
          <SectionSummary
            title={title}
            total={total}
            showDecimals={showDecimals}
          />
        </>
      ) : (
        <div style={{ padding: `0 var(--lg) var(--lg)` }}>
          You currently do not have any gift aid.
        </div>
      )}
    </>
  );
}

GiftAid.displayName = "GiftAid";
GiftAid.propTypes = {
  showDecimals: PropTypes.bool,
};
